import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftRebateSettlement,
  GiftRebateSettleBody,
  GiftRebateSettleResult,
  GiftRebateSettlementPatchBody,
} from './giftRebateSettlement.interface';

// 조회 prefix는 호출자 role에 따라 분기한다.
// - Admin: 전체 정산 조회
// - GiftAgent(마리): /gift-agent 읽기 전용 — 마리 경유(viaMari) 상조 건만 백엔드에서 스코프
export type GiftRebateSettlementRole =
  | LowerRole.Admin
  | LowerRole.BugoAgencyAdmin
  | LowerRole.GiftAgent;

// ===== 조회 =====

export const listGiftRebateSettlements = async (
  filter: Record<string, unknown> = {},
  populate: unknown[] = [],
  options: Record<string, unknown> = { sort: { year: -1, month: -1 } },
  role: GiftRebateSettlementRole = LowerRole.Admin,
): Promise<GiftRebateSettlement[]> => {
  const { data } = await api_.get<GiftRebateSettlement[]>(
    `/${role}/gift-rebate-settlement?${queryString({ filter, populate, options })}`,
  );
  return data;
};

export const getGiftRebateSettlementById = async (
  id: string,
  populate: unknown[] = [],
  role: GiftRebateSettlementRole = LowerRole.Admin,
): Promise<GiftRebateSettlement> => {
  const { data } = await api_.get<GiftRebateSettlement>(
    `/${role}/gift-rebate-settlement/${id}?${queryString({ populate })}`,
  );
  return data;
};

export const countGiftRebateSettlements = async (
  filter: Record<string, unknown> = {},
  role: GiftRebateSettlementRole = LowerRole.Admin,
): Promise<number> => {
  const { data } = await api_.get<number>(
    `/${role}/gift-rebate-settlement/count?${queryString({ filter })}`,
  );
  return data;
};

// ===== 집행 (Admin 전용) =====

export const settleGiftRebate = async (
  body: GiftRebateSettleBody,
): Promise<GiftRebateSettleResult> => {
  const { data } = await api_.post<GiftRebateSettleResult>(
    `/${LowerRole.Admin}/gift-rebate-settlement/settle`,
    body,
  );
  return data;
};

// ===== 수정 (Admin 전용) =====

export const patchGiftRebateSettlement = async (
  id: string,
  body: GiftRebateSettlementPatchBody,
): Promise<GiftRebateSettlement> => {
  const { data } = await api_.patch<GiftRebateSettlement>(
    `/${LowerRole.Admin}/gift-rebate-settlement/${id}`,
    body,
  );
  return data;
};

// ===== 삭제 (Admin 전용) =====

export const deleteGiftRebateSettlement = async (id: string): Promise<void> => {
  await api_.delete(`/${LowerRole.Admin}/gift-rebate-settlement/${id}`);
};
